import React from "react"
import Icon, { IIconProps } from "./icon"

function NewsroomIcon(props: IIconProps): JSX.Element {
  return (
    <Icon {...props}>
      <path d="m10.48,23.49a0.39,0.39 0 0 1 -0.06,0a0.51,0.51 0 0 1 -0.24,-0.1a0.52,0.52 0 0 1 -0.09,-0.09a0.48,0.48 0 0 1 -0.06,-0.11l-3.72,-8.37l-5.53,-2.76a0.48,0.48 0 0 1 -0.14,-0.11s0,0 0,0s0,0 0,0l0,0a0.5,0.5 0 0 1 -0.13,-0.34a0.48,0.48 0 0 1 0.04,-0.2a0.49,0.49 0 0 1 0.12,-0.16l0,0l0,0l0,0a0.52,0.52 0 0 1 0.12,-0.08l21.81,-10.44a0.5,0.5 0 0 1 0.7,0.52l-2.84,19.92a0.5,0.5 0 0 1 -0.69,0.38l-5.53,-2.46l-3.36,4.2l0,0a0.5,0.5 0 0 1 -0.09,0.09a0.48,0.48 0 0 1 -0.12,0.07a0.51,0.51 0 0 1 -0.12,0.03a0.45,0.45 0 0 1 -0.06,0m-3.18,-8.86l2.96,6.66l0.68,-4.05a0.07,0.07 0 0 1 0,-0.01a0.49,0.49 0 0 1 0.03,-0.1a0.51,0.51 0 0 1 0.06,-0.1l6.92,-9.99l-10.64,7.6zm4.51,3.39l-0.53,3.19l2.02,-2.53l-1.49,-0.66zm0.36,-0.92l7.39,3.29l2.62,-18.36l-20.08,9.6l4.52,2.26l13.04,-9.31a0.5,0.5 0 0 1 0.69,0.68l-8.19,11.84z" />
    </Icon>
  )
}

export default NewsroomIcon
